module.exports = __webpack_public_path__ + "img/1523680655.3f17d2cc.jpg";